export default __webpack_public_path__ + "static/media/holycats.36deec3e.png";